/*
 * @Description: 商城商品分组相关接口
 */
import request from './request';

/**
 * @description: 商品分组列表
 */
export function getGoodsGroup(params) {
    return request('/mall/goods-group/list', {
        method: 'GET',
        params,
    });
}

/**
 * @description: 商品分组新增
 */
export function addGoodsGroup(params) {
    return request('/mall/goods-group', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 商品分组修改
 */
export function putGoodsGroup(params) {
    return request('/mall/goods-group', {
        method: 'PUT',
        params,
    });
}

/**
 * @description: 商品分组修改排序
 */
export function putGoodsGroupSort(params) {
    return request('/mall/goods-group/sort', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 商品分组删除
 */
export function deleteGoodsGroup(id) {
    return request(`/mall/goods-group?id=${id}`, {
        method: 'DELETE',
    });
}

/**
 * @description: 商品分组详情
 */
export function getGoodsGroupDetail(params) {
    return request('/mall/goods-group/detail', {
        method: 'GET',
        params,
    });
}
